function incomingCallAction(buttonId, retry: number = 4) {
    if (retry === 0) {
        return;
    }
    const button = document.getElementById(buttonId);
    if (button) {
        button.click();
        return;
    } else {
        setTimeout(() => incomingCallAction(buttonId, retry - 1), 1000);
    }
}

export function acceptIncomingCallAction() {
    incomingCallAction("incoming-call-accept-button")
}

export function declineIncomingCallAction() {
    incomingCallAction("incoming-call-reject-button")
}
